import React from 'react';

import * as S from './style';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

const CategoryTemplate = ({ children, className }: IProps) => (
  <S.CategoryTemplate className={className}>{children}</S.CategoryTemplate>
);

export default CategoryTemplate;
